import './_NoSubscribedFeed.scss';
import Card from 'react-bootstrap/Card';
import Button from '../../../../ntisui/Atoms/Buttons';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import { INoSubscribedFeeds } from '../types/INoSubscribedFeeds';

const NoSubscribedFeed = (props: INoSubscribedFeeds) => {
  return (
    <Card
      className="nosubscribeddatafeed-card-container"
      data-testid="nosubscribeddatafeed-card"
    >
      <Card.Text className="card-text">{props.message}</Card.Text>
      {props.button && (
        <Button
          isDisabled={props.disabled}
          className="card-button"
          onClick={() => props.onClick()}
          variant={ButtonVariant.OutlinePrimary}
          label={litrals.retry}
        />
      )}
      <Card.ImgOverlay className="image-overlay text-center">
        <Card.Img src={props.image} alt="Card image" />
      </Card.ImgOverlay>
    </Card>
  );
};
export default NoSubscribedFeed;
